import React from 'react';
/* global showResellers, SetProductLink, showConfirmation */

import {translate} from "../Services/translation";
import BuyButtonWrapper from "./BuyButtonExtension";

const BuyOnline = function ({isMuurikka, productOnlineResellers, productItem}) {
    return (
        <div id="BuyOnlinePopup"
            className="product-detail__buy popup hide buy-online-popup"
            style={{width: '100%', background: 'rgba(0, 0, 0, 0.2)'}}
            onClick={() => window.showResellers(productItem.isBuyable)}
        >
            <div className="cart__outerdiv">
                <a className="cart__closenullarea" onClick={() => showResellers(productItem.isBuyable)}> </a>
            </div>

            <div id="Container" className="product-detail__container" onClick={e => e.stopPropagation()}>
                <div className="product-detail__buy-heading">
                    <h6 className="buy-text">{translate('buyorproductsonlineheader')}</h6>
                    <a href="#" className="close" onClick={(e) => {
                        e.preventDefault();
                        showResellers(productItem.isBuyable)
                    }}>
                        &#10006;
                    </a>
                </div>

                <input id="hdncartQty" type="hidden"/>
                <div className="resellers-container">
                    <input id="hdnHref" type="hidden"/>

                    {productOnlineResellers.length > 0 && productOnlineResellers.map(item => 
                        <div className="store-button onlinediv" key={item.customerNumber}>
                            <img src={item.logoUrl} alt={item.name} />
                            <a href="#" id="onlineResellers"
                                className="habo-button--white onlinelink"
                                onClick={() => window.setProductLink(item.productLink)}
                            >
                                {translate('buyorproductsonlinelinktext')}
                            </a>
                        </div>
                    )}
                    <div id="divHaboProducts">
                        <div className="product-detail__buy-heading">
                            <h6 className="buy-text">{translate('product.buyproductsheader')}</h6>
                        </div>
                        <div className="store-button onlinediv">
                            {/*@Html.ImageFor(x => Model.ProductItem.Logo, maxSize: new Size(2, produ*/}
                            <a href="#" className="habo-button--white onlinelink" onClick={() => showConfirmation()}>
                                {translate('buyproductsconfirmationlinktext')}
                            </a>

                            {productItem.isBuyable && 
                                <div>
                                    <BuyButtonWrapper />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BuyOnline;
